import React, { useCallback, useEffect, useState } from "react";
import PostHooks from "../../Api/PostHooks";
import { use } from "react";
import Page from "../../Components/Page";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import AlertComponent from "../../Components/AlertComponent";
import TableauVisualize from "../../Components/TableauVisualize";
import PageLoader from "../../Components/PageLoader";
import { Box, Button } from "@mui/material";
import { ArrowBack } from "@mui/icons-material";

const ViewReport = () => {
  const location = useLocation();
  const navigate = useNavigate();
  const loggedInUser = useSelector((state) => state.auth.user);

  const [snackbar, setSnackbar] = useState({
    open: false,
    message: "",
    severity: "info",
  });
  const [token, setToken] = useState();
  const [view, setView] = useState(location.state.view);

  const [loading, response, request] = PostHooks();

  const handleSnackbarClose = () => {
    setSnackbar((prev) => ({ ...prev, open: false }));
  };

  const fetchToken = useCallback(async () => {
    try {
      const resp = await request({
        url: `get_bi_token`,
        body: {},
      });

      if (resp && resp.status === 200 && resp.data.StatusCode === 0) {
        setToken(resp.data.Token);
      } else {
        const errorMessage =
          resp?.data?.StatusMessage ??
          resp?.data?.message ??
          resp.message ??
          "An unexpected error occurred. Please try again.";

        setSnackbar({
          open: true,
          severity: "error",
          message: errorMessage,
        });
      }
    } catch (error) {
      const errorMessage =
        error.response?.data?.StatusMessage ??
        error.response?.data?.message ??
        error.message ??
        "An unexpected error occurred. Please try again.";

      setSnackbar({
        open: true,
        severity: "error",
        message: errorMessage,
      });
    }
  }, []);

  useEffect(() => {
    fetchToken();
  }, [fetchToken]);

  console.log("view", view);
  console.log("response", response);

  return (
    <Page
      title={`${view.name} View`}
      actions={
        <Box>
          <Button
            variant="outlined"
            startIcon={<ArrowBack />}
            onClick={() => navigate(-1)}
          >
            Back
          </Button>
        </Box>
      }
    >
      <AlertComponent
        open={snackbar.open}
        handleSnackbar={handleSnackbarClose}
        severity={{ severity: snackbar.severity, message: snackbar.message }}
      />

      {loading ? (
        <PageLoader />
      ) : (
        <TableauVisualize link={view.link} token={token} />
      )}
    </Page>
  );
};

export default ViewReport;
